<template>
    <div id="modal-ticket-asset-select-form" class="modal fade" tabindex="-1" role="dialog"
         style="display: none;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title font-normal" id="modalTitle">Select {{ app.lang.assetName }}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>

                <div class="modal-body">
                    <form class="form">
                        <div class="form-group">
                            <label for="asset">{{ app.lang.assetName }}</label>
                            <div class="row">
                                <div class="col-sm-12">
                                    <remote-select
                                        v-model="selectedAsset"
                                        @focus="searchAssets"
                                        :remote-method="searchAssets"
                                        :loading="loading"
                                        :data="assets"
                                        item-label="name"
                                        placeholder="Start typing to search assets, addresses or linked contacts">
                                        <template slot-scope="props">
                                            <assets-drop-down-item :asset="props.item"></assets-drop-down-item>
                                        </template>
                                    </remote-select>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-success waves-effect waves-light" @click.prevent="updateTicketAsset"
                            :disabled="assetSelectForm.busy">Change
                    </button>

                    <button type="button" class="btn btn-default waves-effect" data-dismiss="modal"
                            :disabled="assetSelectForm.busy">Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssetSearch from "../../mixins/asset-search";

export default {
    name: "ticket-asset-select-form",
    mixins: [AssetSearch],
    props: ["ticket"],

    data () {
        return {
            assetSelectForm: new AppForm({}),
            selectedAsset: null
        };
    },

    mounted () {
        Bus.$on("show-asset-select-form", function () {
            $("#modal-ticket-asset-select-form").modal("show");
        });
    },

    methods: {
        updateTicketAsset () {
            this.assetSelectForm.selected_asset_id = this.selectedAsset?.id;
            App.patch("/tickets/" + this.ticket.id + "/asset/change", this.assetSelectForm)
            .then(response => {
                toastr.success(App.lang.assetName + " updated!");
                Bus.$emit("ticket-asset-updated", response);
                $("#modal-ticket-asset-select-form").modal("hide");
            })
            .catch(errors => {
                toastr.error("Could not update " + App.lang.asset.name + "!");
            });
        },
    },
};
</script>
